const CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID;
const ISSUER_URL = process.env.REACT_APP_OKTA_ISSUER_URL;
const ISSUER_ID = process.env.REACT_APP_OKTA_ISSUER_ID;

const oktaConfig = {
  clientId: CLIENT_ID,
  issuer: `${ISSUER_URL}oauth2/${ISSUER_ID}`,
  redirectUri: window.location.origin + '/oktalogin',
};

export default oktaConfig;
